import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class AfterPlayerCareerEndEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}